/* eslint no-unused-vars: 0 */
/* eslint  no-undef: 0 */

import React     from 'react';
import PropTypes from 'prop-types';
import moment    from 'moment';
import Autocomplete  from './Autocomplete';
import { Redirect } from 'react-router-dom';

import { cuisineTypes } from './common/cuisineTypes';
import { base }   from '../config';

import { SingleDatePicker } from 'react-dates';
import { Dropdown, Button } from 'semantic-ui-react';

import 'react-dates/lib/css/_datepicker.css';
import styles from '../styles/form.styl';

const cuisineOptions = (cuisines) => {
  return cuisines.map((c) => { return { text: '[' + c.symbol + '] - ' + c.type, value: c.type }; });
};

const searchContext = (string, context) => {
  const data = context.reduce( (datum, value) => {
    datum[(value.id).split('.')[0]] = value.text;
    return datum;
  }, {});
  return data[string];
};

class VisitsForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      submitted: false,
      address: '',
      name: '',
      date: new moment(),
      rating: 0,
      cuisine: 'other',
      placeId: null,
      city: null,
      state: null,
      full_address: '',
      area: '',
      review: ''
    };
    this.onChange = (address) => this.setState({ address });
  }

  setVisit() {
    return {
      data: {
        name: this.state.name,
        address: this.state.address,
        city: this.state.city,
        state: this.state.state,
        lon: this.state.lon,
        lat: this.state.lat,
        cuisine: this.state.cuisine,
        uid: this.context.user.uid,
        placeId: this.state.placeId,
        rating: this.state.rating,
        date: moment(this.state.date).format(),
        area: this.state.area,
        username: this.context.user.username,
        first: this.context.user.first,
        last: this.context.user.last,
        review: this.state.review
      }
    };
  }

  handleFormSubmit = (event) => {
    event.preventDefault();
    this.setState({ submitting: true });
    console.log(this.setVisit());
    base.push('visits_2017_08_02', this.setVisit())
      .then(newVisit => { this.setState({ submitting: false, submitted: true }); })
      .catch(err => { console.log(err); });
  }

  handleSelect = (value) => {
    console.log(value);
    this.setState({
      lon: value.center[0],
      lat: value.center[1],
      area: searchContext('neighborhood', value.context),
      address: value.properties.address,
      name: value.text,
      city: searchContext('locality', value.context),
      state: searchContext('region', value.context),
      placeId: value.id
    });
  }

  handleRatingPush = (e, data) => {
    event.preventDefault();
    this.setState({ rating: data.value });
  }

  handleCuisineSelect = (e, data) => {
    this.setState({ cuisine: data.value });
  }

  handleAreaChange = (e) => {
    this.setState({ area: e.target.value });
  }

  handleReviewChange = (e) => {
    this.setState({ review: e.target.value });
  }

  render() {
    const inputProps = {
      value: this.state.address,
      onChange: this.onChange,
      placeholder: 'Search Places...'
    };

    if(this.state.submitted === false) {
      return (
        <div className={this.state.submitting ? 'submitting' : ''}>
          <div>
            <div className="panel panel-form">
              <div className="panel-header">
                <h1>Y'all Feastin'?</h1>
              </div>
              <form className="SimpleForm" className="visits-form" onSubmit={this.handleFormSubmit}>
                <div className="form-item">
                  <label>Location</label>
                  <Autocomplete onSelect={ this.handleSelect } className="location" />
                </div>
                <Dropdown placeholder="Cuisine Type" fluid search selection onChange={ this.handleCuisineSelect } options={ cuisineOptions(cuisineTypes) } />
                <div className="ratings-button-group">
                  <Button.Group className="plus-minus">
                    <Button as="button" type="button" onClick={ this.handleRatingPush } size="large" value={1}>+1</Button>
                    <Button as="button" type="button" onClick={ this.handleRatingPush } size="large" value={-1}>-1</Button>
                  </Button.Group>
                  <Button as="button" type="button" className="bless-button" onClick={ this.handleRatingPush } size="large" color="purple" value={'bless'}>#bless 👑</Button>
                </div>
                <div className="form-item">
                  <label>Neighborhood</label>
                  <input type="text" className="form-field" onChange={ this.handleAreaChange } value={ this.state.area } />
                </div>
                <div className="form-item">
                  <label>Review</label>
                  <input type="text" className="form-field" onChange={ this.handleReviewChange } value={ this.state.review } />
                </div>
                <div className="submit-button">
                  <Button onClick={ this.handleFormSubmit } size="large" color="blue">Add Visit</Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      );
    }
    return (
      <Redirect to="/" />
    );
  }
}

VisitsForm.contextTypes = {
  user: PropTypes.object
};

export default VisitsForm;



// WEBPACK FOOTER //
// ./client/components/VisitsForm.js